import { notification } from 'antd';

export const notificationStrings = {
	success: 'success',
	info: 'info',
	warning: 'warning',
	error: 'error',
};

export const openNotificationWithIcon = (type = notificationStrings.success, title = null, message = null, duration = 3) => {
	notification[type]({
		message: title,
		description: message,
		duration: duration,
	});
};
